<template>
  <PageLayout title="Tasks" class="!p-0">
    <div class="h-full hidden sm:flex flex-col overflow-hidden">
      <div class="flex flex-grow bg-gray-50">
        <div
          class="flex flex-col overflow-y-auto border-r border-gray-200 bg-white pt-2 pb-2 w-1/6 min-w-min"
        >
          <div
            class="flex items-center space-x-2 pt-4 pl-8 text-xl font-medium text-gray-900"
          >
            <h1>{{ t("admin.settings.personal.title") }}</h1>
          </div>
          <div class="mt-5 flex flex-grow flex-col">
            <nav
              class="flex-1 space-y-8 bg-white px-4 sm:px-6 lg:px-8"
              aria-label="Sidebar"
            >
              <div class="space-y-1">
                <Link
                  v-for="item in settings"
                  :key="item.name"
                  :href="item.href"
                  :class="[
                    isActive(item.href)
                      ? 'bg-gray-50 text-gray-900 hover:text-gray-900 hover:bg-gray-100'
                      : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50 cursor-pointer',
                    'group flex items-center px-2 py-2 text-sm font-medium rounded-sm',
                  ]"
                >
                  <component
                    :is="item.icon"
                    :class="[
                      isActive(item.href)
                        ? 'text-gray-900'
                        : 'text-gray-500 group-hover:text-gray-500',
                      'mr-3 flex-shrink-0 h-5 w-5',
                    ]"
                    aria-hidden="true"
                  />
                  <span class="truncate flex-1">{{ item.name }}</span>
                </Link>
              </div>
            </nav>
          </div>
        </div>
        <div class="flex flex-grow flex-col">
          <slot />
        </div>
      </div>
    </div>
    <div class="sm:hidden">
      <slot />
    </div>
  </PageLayout>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";
import PageLayout from "@/Layouts/PageLayout.vue";
import route from "ziggy-js";
import SettingsOne from "@/Tailwind/Icon/SettingsOne";
import UserCircle from "@/Tailwind/Icon/UserCircle";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

const settings = [
  {
    name: t("admin.settings.personal.profile.title"),
    icon: UserCircle,
    href: route("settings.user.profile.index"),
    current: true,
  },
  {
    name: t("admin.settings.personal.account.title"),
    icon: SettingsOne,
    href: route("settings.user.account.index"),
    current: false,
  },
];

function isActive(to) {
  const url = `${location.origin}${location.pathname}`;

  return to === url;
}
</script>
